import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { 
  Truck, 
  XCircle,
  ArrowRight
} from 'lucide-react';

export default function PaymentCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <motion.div 
        className="max-w-md w-full text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <div className="w-10 h-10 bg-primary rounded-sm flex items-center justify-center">
            <Truck className="w-6 h-6 text-white" />
          </div>
          <span className="font-bold text-xl" style={{ fontFamily: 'Barlow Condensed' }}>
            THE HOTSHOT MARKETPLACE
          </span>
        </Link>

        <div className="bg-card border border-border rounded-sm p-8">
          <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-yellow-500" />
          </div>
          <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Barlow Condensed' }}>
            PAYMENT CANCELLED
          </h1>
          <p className="text-muted-foreground mb-6">
            Your payment was not completed. The job quote is still available.
          </p>
          <div className="space-y-3">
            <Button 
              className="w-full btn-active gap-2"
              onClick={() => navigate('/dashboard')}
              data-testid="go-to-dashboard-btn"
            >
              Return to Dashboard
              <ArrowRight className="w-4 h-4" />
            </Button>
            <Button 
              variant="outline"
              className="w-full"
              onClick={() => navigate(-1)}
            >
              Try Again
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
